
import axios from 'axios';

const PROXY = process.env.REACT_APP_URL + "api/";

export const dropdownPropertyField = (type) => async()=>{
    const res = await axios.get(`${PROXY}property-fields/dropdown?type=${type}`);

    return res?.data?.result;
}